import * as React from 'react';
import { currentSecondaryDimensionIndexContext } from './context';
export var CurrentSecondaryDimensionIndexProvider = function (props) {
    var index = props.index, children = props.children;
    return (React.createElement(currentSecondaryDimensionIndexContext.Provider, { value: index }, children));
};
